import { Icon } from "./Icon"

export function PayReserveLabel({ processing = false }: { processing?: boolean }) {
    return <><Icon name="lock" /><span>{processing ? "Processing payment…" : "Pay & Reserve"}</span></>
}
